import clsx from 'clsx';
import { FaCcAmex, FaCcMastercard, FaCcVisa } from 'react-icons/fa6';
import { PiCreditCardThin } from 'react-icons/pi';
import { MasterCardSvg } from './MasterCardSvg.tsx';

export interface CreditCardIconProps {
  brand: 'amex' | 'mastercard' | 'visa';
  className?: string;
  colored?: boolean;
}

export function CreditCardIcon({ brand, className, colored = true }: CreditCardIconProps) {
  if (brand === 'amex') {
    return <FaCcAmex className={clsx(className, colored && 'text-[#007bc1]')} />;
  }

  if (brand === 'mastercard') {
    return colored ? (
      <MasterCardSvg className={className} />
    ) : (
      <FaCcMastercard className={className} />
    );
  }

  if (brand === 'visa') {
    return <FaCcVisa className={clsx(className, colored && 'text-[#0157a2]')} />;
  }

  return <PiCreditCardThin className={className} />;
}
